import React from 'react';
import { COLORS } from '../../../constants/colors';
export const Dots = () => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("circle", { cx: "4", cy: "12", r: "2", fill: COLORS.PURPLE[900] }),
    React.createElement("circle", { cx: "12", cy: "12", r: "2", fill: COLORS.PURPLE[900] }),
    React.createElement("ellipse", { cx: "20", cy: "12", rx: "2", ry: "2", fill: COLORS.PURPLE[900] })));
